<div class="availability hmf-display-flex hmf-flex-wrap hmf-justify-content-between hmf-align-items-center hmf-align-content-center" [ngClass]="{'centered' : !selectedStoreId}">
    <div *ngIf="productAvailabilityData && !isComingSoon && !isOOS" class="shipping-availability hmf-pb-xxxs">
        <homefield-icon
        [class]="shippingMessage?.class"
        height="10px"
        width="10px"
        [name]="shippingMessage?.icon">
        </homefield-icon>
        {{shippingMessage?.text}}
    </div>
    <div *ngIf="selectedStoreId && !isComingSoon && !isOOS" class="store-availability hmf-pb-xxxs" >
        <homefield-icon
        [class]="pickupMessage?.class"
        height="10px"
        width="10px"
        [name]="pickupMessage?.icon">
    </homefield-icon>
    {{pickupMessage?.text}}
    </div>
</div>
